'use client'

import React, { PropsWithChildren } from 'react'
import { useParams } from 'next/navigation'
import { SubCategory } from '@/lib/categories/categories'
import SubCategoriesSlider from '@/components/assets-explorer/subcategories-slider'

/**
 * This is a client component that will render the SubCategoriesSlider only when a subcategory is selected.
 * @param children
 * @constructor
 */
export default function SubCategoriesSliderToggle({
  mainCategorySlug,
  categorySlug,
  subCategories,
}: PropsWithChildren<{
  mainCategorySlug: string
  categorySlug: string
  subCategorySlug?: string
  subCategories?: SubCategory[]
  // When true, we will try to get subcategory with the slug provided in the URL
  fallbackCategorySlug?: boolean
  className?: string
}>) {
  const { subCategory: subCategorySlug } = useParams<{
    subCategory: string
  }>()

  return subCategorySlug ? (
    <div className="tw-mx-2 tw-mb-6 tw-overflow-hidden">
      <SubCategoriesSlider
        mainCategorySlug={mainCategorySlug}
        categorySlug={categorySlug}
        subCategorySlug={subCategorySlug}
        subCategories={subCategories}
        fallbackCategorySlug
      />
    </div>
  ) : null
}
